import { render } from "./TiketPage.vue?vue&type=template&id=482c7cc4&scoped=true"
import script from "./TiketPage.vue?vue&type=script&lang=js"
export * from "./TiketPage.vue?vue&type=script&lang=js"

import "./TiketPage.vue?vue&type=style&index=0&id=482c7cc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-482c7cc4"]])

export default __exports__